<!--
 * @Description:
 * @Date: 2021-11-11 18:16:01
-->
<template>
  <el-row type="flex" justify="start" align="middle">
    <el-checkbox
      style="margin-right: 30px"
      :disabled="!tableData.length"
      :value="selectedSize > 0"
      @change="change"
      :indeterminate="indeterminate"
    >
      结果全选
    </el-checkbox>
    <span>
      已选
      <span>{{ selectedSize || 0 }}</span>
      项， 批量操作：
    </span>
    <el-button
      :disabled="!actionEnabled"
      type="primary"
      size="small"
      @click="pass(2)"
    >
      批量通过
    </el-button>
    <el-button
      :disabled="!actionEnabled"
      type="primary"
      size="small"
      plain=""
      @click="pass(3)"
    >
      批量驳回
    </el-button>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import request from '@/tools/request';
import noPass from '@/page/project-record/services/audit-no-pass.js';
import Vue from 'vue';

export default {
  name: 'task-record-batch-action',
  computed: {
    ...mapState('dataAnalysis/task', [
      'tableData',
      'pageTotal',
      'selectedSize',
      'isAll',
      'maxSelectedSize'
    ]),
    // ...mapState('dataAnalysis', ['projectDetail']),
    actionEnabled() {
      return this.selectedSize > 0;
    },
    indeterminate() {
      return this.selectedSize > 0 && this.selectedSize < this.maxSelectedSize;
    }
  },
  methods: {
    change() {
      let isSelected = this.selectedSize > 0 ? false : true;
      isSelected = this.indeterminate ? true : isSelected;
      this.selectAll(isSelected).then(res => {
        const { list, total, query } = res;
        this.$parent.tableData = list;
        this.$parent.tableTotal = total;

        setTimeout(() => {
          for (const k in query) {
            this.$parent.$refs.baseForm.form[k] = query[k];
          }
        });
      });
    },
    ...mapActions('dataAnalysis/task', ['selectAll', 'batchAudit']),
    /**
     *
     * @param type 2：过 3：驳回
     */
    async pass(type) {
      if (type === 2) {
        await this.batchAudit(type);
      }
      if (type === 3) {
        const rejectResp = await noPass(this.selectedSize);
        const params = {
          projectId: this.$route.query.id,
          auditStatus: type
        };
        params.remarkType = rejectResp.type;
        params.remark = rejectResp.remark;

        // 展示 loading
        const loading = this.$loading({
          lock: true,
          text: `0 / ${this.selectedSize}`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // 轮询进度
        const queryCountTimer = setInterval(async () => {
          const {
            data: { data }
          } = await request.post(
            '/rest/cso/saas/taskRecord/auditOssStatus/all/queryCount',
            {
              projectId: this.$store.state.dataAnalysis.projectDetail.projectId,
              source: 1 //1任务记录 2 快捷审核
            }
          );
          loading.setText(`${data} / ${this.selectedSize}`);
        }, 500);
        const {
          data: { message }
        } = await request
          .post(
            '/rest/cso/saas/taskRecord/auditOssStatus/all',
            params
            // { serviceLoading: true }
          )
          .finally(() => {
            if (!loading) return;
            loading.setText(`${this.selectedSize} / ${this.selectedSize}`);
            clearInterval(queryCountTimer);
            loading.close();
          });
        this.$message.success(message);
      }
      await this.$parent.tableSearch({ isSelected: '0' });
    }
  }
};
</script>

<style scoped></style>
